import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { LocaleProvider } from '../context/locale';
import Footer from './footer/Footer';
import Header from './header/Header';
import { Helmet } from 'react-helmet';
import { setHeadContent } from '../utils/functions';

const Layout = ({ children, pageSettings, isEmbedded, bannerTop }) => {
  const { site, liferaySubmoduleCustomFieldsSite } = useStaticQuery(
    graphql`
      query {
        site: site {
          siteMetadata {
            title
          }
        }
        liferaySubmoduleCustomFieldsSite: liferaySubmoduleCustomFieldsSite {
          headerContent {
            content {
              scripts {
                value
              }
            }
          }
        }
      }
    `
  );

  const _data = pageSettings || {
    pageType: 'business',
    showChangeLanguageButton: false,
    disableLinkLogo: false,
    linkLangMap: { '': '' },
    langCode: 'it-IT',
    hideSocialButton: false,
  }; //Fallback nel caso in cui la pagina non abbia i custom field salvati o sia una pagina statica.

  const headerSettings = {
    pageType: _data.pageType,
    showChangeLanguageButton: _data.showChangeLanguageButton,
    disableLinkLogo: _data.disableLinkLogo,
    linkLangMap: _data.linkLangMap,
    langCode: _data.langCode,
    link: _data.link,
    hideSocialButton: _data.hideSocialButton,
    lateralStickerAnchor: _data.lateralStickerAnchor,
  };

  const footerSettings = {
    pageType: _data.pageType,
    disableLinkLogo: _data.disableLinkLogo,
    langCode: _data.langCode,
  };

  const headerCustomScripts =
    liferaySubmoduleCustomFieldsSite?.headerContent?.content?.scripts;

  const headerCustomScriptsEmbedded = headerCustomScripts?.filter(
    (script) =>
      !script?.value.includes('OptanonWrapper') &&
      !script?.value.includes('https://cdn.cookielaw.org')
  );

  const headerScripts = isEmbedded
    ? headerCustomScriptsEmbedded
    : headerCustomScripts;

  return (
    <LocaleProvider langCode={_data.langCode}>
      {headerScripts && <Helmet>{setHeadContent(headerScripts)}</Helmet>}
      {!isEmbedded && (
        <Header
          siteTitle={site.siteMetadata.title}
          settings={headerSettings}
          bannerTop={bannerTop}
        />
      )}
      {children}
      {!isEmbedded && <Footer settings={footerSettings} />}
    </LocaleProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
